import React from 'react';
import { useToast } from '../../hooks/use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm">
      {toasts.map(({ id, title, description, variant, duration, open, onOpenChange, ...props }) => (
        <div
          key={id}
          className={`
            rounded-lg border p-4 shadow-lg transition-all duration-300
            ${variant === 'destructive' ? 'bg-red-50 border-red-200 text-red-800' : ''}
            ${variant === 'secondary' ? 'bg-yellow-50 border-yellow-200 text-yellow-800' : ''}
            ${variant === 'outline' ? 'bg-blue-50 border-blue-200 text-blue-800' : ''}
            ${!variant || variant === 'default' ? 'bg-green-50 border-green-200 text-green-800' : ''}
          `}
          {...props}
        >
          {title && (
            <div className="font-semibold text-sm mb-1">
              {title}
            </div>
          )}
          {description && (
            <div className="text-sm">
              {description}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}